import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import {
  AiOutlineEdit,
  AiOutlinePrinter,
  AiOutlineStar,
  AiOutlineUser,
} from "react-icons/ai";
import { BiUserPin } from "react-icons/bi";
import {
  BsFillDiagram3Fill,
  BsFillFileEarmarkBarGraphFill,
  BsGraphUp,
  BsStack,
} from "react-icons/bs";
import { HiOutlineUserGroup } from "react-icons/hi";
import {
  MdAddChart,
  MdHotelClass,
  MdOutlineCompareArrows,
  MdOutlineSdCardAlert,
} from "react-icons/md";
import { SiGoogleclassroom } from "react-icons/si";
import { connect } from "react-redux";
import { getDashboardData } from "../../actions/Dashboard.action";
import Layout from "../../components/shared/Layout/Layout";
import StatCard from "../../components/shared/StatCard/StatCard";

const DashboardPage = ({ data, getDashboardData }) => {
  useEffect(() => {
    if (!data) {
      getDashboardData();
    }
  }, []);
  return (
    <Layout>
      {data ? (
        <Row className="pt-0">
          <Col md={3} className="py-3">
            <StatCard
              title="Total Student"
              icon={<AiOutlineUser />}
              count={data.student}
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Total Class"
              icon={<BsFillDiagram3Fill />}
              count={data.grade}
            />
          </Col>

          <Col md={3} className="py-3">
            <StatCard
              title="Total Batch"
              icon={<HiOutlineUserGroup />}
              count={data.batch}
            />
          </Col>

          {/* <Col md={12} className="py-3">
            <span className="d-block fs-4 border-bottom pt-4">Quick Links</span>
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Add Result"
              icon={<MdAddChart />}
              link="/admin/mark/add"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Edit Result"
              icon={<AiOutlineEdit />}
              link="/admin/mark/edit"
            />
          </Col>

          <Col md={3} className="py-3">
            <StatCard
              title="Print Result"
              icon={<AiOutlinePrinter />}
              link="/admin/mark"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="View Result"
              icon={<BsFillFileEarmarkBarGraphFill />}
              link="/admin/view-result"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Top Result"
              icon={<AiOutlineStar />}
              link="/admin/mark/top"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Comparison"
              icon={<MdOutlineCompareArrows />}
              link="/admin/comparison"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Individual Result"
              icon={<BiUserPin />}
              link="/admin/individual-result"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Academic Graph"
              icon={<BsGraphUp />}
              link="/admin/academic-graph"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Alarming Student"
              icon={<MdOutlineSdCardAlert />}
              link="/admin/alarming-student"
            />
          </Col>

          <Col md={3} className="py-3">
            <StatCard
              title="Class Performance"
              icon={<SiGoogleclassroom />}
              link="/admin/class-performance"
            />
          </Col>
          <Col md={3} className="py-3">
            <StatCard
              title="Class Summary"
              icon={<MdHotelClass />}
              link="/admin/class-summary"
            />
          </Col> */}
        </Row>
      ) : (
        <></>
      )}
    </Layout>
  );
};
const mapStateToProps = (state) => ({
  data: state.auth.dashboard,
});
export default connect(mapStateToProps, { getDashboardData })(DashboardPage);
